import React from "react";
import LightSpeed from "react-reveal/LightSpeed";

const AboutUs = () => {
  return (
    <div
      className="h-auto mb-3 flex my-4 md:min-h-screen justify-center items-center"
      id="about"
    >
      <div className="flex flex-col md:flex-row items-center justify-center max-w-12xl mx-auto ">
        <LightSpeed left>
          <div className="aspect-video mb-4 w-2/3">
            <img
              className="h-full w-full object-fit"
              src="./assets/images/About.jpg"
              alt="hero"
            />
          </div>
        </LightSpeed>

        <LightSpeed right cascade>
          <div className="w-auto md:ml-20 md:text-left text-center px-5">
            <h2 className="md:text-8xl text-6xl mb-7 md:translate-y-[-10px] font-bold md-5 text-transparent bg-clip-text bg-gradient-to-r from-[#DD2476] via-[#FB680B] to-[#FF522C]">
              About me
            </h2>
            <p className="font-semibold text-xl w-auto">
              Currently, I am pursuing Bachelor of Technology in Computer
              Engineering from{" "}
              <span className="text-yellow-500">
                Delhi Technological University
              </span>
              , New Delhi.
              <br />
              <br />I have build multiple projects with & without team. And won
              second position in a Hackathon.
              <br />
              <br />I love playing cricket, reading books and travelling.
            </p>
          </div>
        </LightSpeed>
      </div>
    </div>
  );
};

export default AboutUs;
